(function () {
  var ARROW_URL = 'https://cdn.shopify.com/s/files/1/0575/3624/9916/files/SVG_Arrow_45deg.svg?v=1778838357';

  function injectArrow(btn) {
    if (!btn || btn.dataset.irArrow) return;
    btn.dataset.irArrow = '1';
    var img = document.createElement('img');
    img.src = ARROW_URL;
    img.alt = '';
    img.style.cssText = 'width:18px;height:18px;flex-shrink:0;display:inline-block;vertical-align:middle;';
    btn.appendChild(img);
  }

  function applyArrows() {
    document.querySelectorAll(
      'kaching-bundle button:not([data-ir-arrow]),' +
      'kaching-bundle a.btn:not([data-ir-arrow]),' +
      '.ir-cta-btn:not([data-ir-arrow])'
    ).forEach(injectArrow);
  }

  document.addEventListener('DOMContentLoaded', function () {
    applyArrows();
    setTimeout(applyArrows, 600);
    setTimeout(applyArrows, 1800);
    new MutationObserver(applyArrows).observe(document.body, { childList: true, subtree: true });
  });
})();

(function () {
  function initIRAccordion() {
    var panels = Array.prototype.slice.call(
      document.querySelectorAll('.product__accordion details')
    );
    if (!panels.length) return;

    panels.forEach(function (details) {
      details.removeAttribute('open');
      var content = details.querySelector('.accordion__content');
      if (content) content.style.maxHeight = '0';

      var summary = details.querySelector('summary');
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = details.hasAttribute('open');

        // Close all
        panels.forEach(function (d) {
          var c = d.querySelector('.accordion__content');
          if (c) c.style.maxHeight = '0';
          d.removeAttribute('open');
        });

        // Open clicked if it was closed
        if (!isOpen && content) {
          details.setAttribute('open', '');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIRAccordion);
  } else {
    initIRAccordion();
  }
})();

(function () {
  function initRatingScroll() {
    var rating = document.querySelector('.ir-rating');
    if (!rating) return;
    rating.style.cursor = 'pointer';
    rating.addEventListener('click', function () {
      var target =
        document.getElementById('ir-reviews') ||
        document.querySelector('#shopify-section-1779021514b2e333f7') ||
        document.querySelector('.loox-reviews') ||
        document.querySelector('[class*="loox"]');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRatingScroll);
  } else {
    initRatingScroll();
  }
})();

(function () {
  var words = ['athletes', 'nutritionists', 'high-performers', 'naturopaths', 'health-optimisers', 'busy individuals'];
  var idx = 0;

  function initTrustedBy() {
    var el = document.querySelector('.ir-trusted-word');
    if (!el) return;
    el.textContent = words[0];

    setInterval(function () {
      el.classList.add('ir-fade-out');
      setTimeout(function () {
        idx = (idx + 1) % words.length;
        el.textContent = words[idx];
        el.classList.remove('ir-fade-out');
      }, 260);
    }, 2200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrustedBy);
  } else {
    initTrustedBy();
  }
})();

/* ── Sticky ATC bar ── */
(function () {

  /* Price constants — must match ir-bundle-widget.js */
  var JAR_PRICE   = 117.00;
  var SPOON_PRICE = 12.99;

  /* Read the currently-selected state directly from the bundle widget DOM.
     This is always accurate because the widget marks its active elements with
     the .active class on every user interaction — no events or globals needed. */
  function calcFromDOM() {
    var activeTab  = document.querySelector('.ir-b-qty-tab.active');
    var activeCard = document.querySelector('.ir-b-option-card.active');
    if (!activeTab || !activeCard) return null;
    var qty         = parseInt(activeTab.getAttribute('data-qty'), 10) || 2;
    var purchaseType = activeCard.getAttribute('data-type') || 'subscribe';
    var isSubscribe = purchaseType === 'subscribe';
    var volDisc     = qty === 2 ? 0.10 : qty === 3 ? 0.15 : 0;
    var subDisc     = isSubscribe ? 0.20 : 0;
    var totalDisc   = 1 - ((1 - volDisc) * (1 - subDisc));
    var price       = parseFloat((JAR_PRICE * qty * (1 - totalDisc)).toFixed(2));
    var fullRRP     = qty >= 2
      ? parseFloat((JAR_PRICE * qty + SPOON_PRICE).toFixed(2))
      : parseFloat((JAR_PRICE * qty).toFixed(2));
    var savings     = parseFloat((fullRRP - price).toFixed(2));
    var savingsPct  = Math.round((savings / fullRRP) * 100);
    return { qty: qty, purchaseType: purchaseType, price: price,
             fullRRP: fullRRP, savings: savings, savingsPct: savingsPct };
  }

  function fmt(n) {
    var fixed = parseFloat(n.toFixed(2));
    var str   = fixed.toString();
    var parts = str.split('.');
    if (parts.length === 1) return '$' + parts[0];
    var dec = parts[1];
    if (dec === '0' || dec === '00') return '$' + parts[0];
    if (dec.length === 1) dec = dec + '0';
    return '$' + parts[0] + '.' + dec;
  }

  function createBar() {
    var bar = document.createElement('div');
    bar.id        = 'ir-sticky-atc';
    bar.className = 'ir-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="ir-sticky-inner">' +
        '<div class="ir-sticky-info">' +
          '<div class="ir-sticky-label"></div>' +
          '<div class="ir-sticky-price-row">' +
            '<s class="ir-sticky-rrp"></s>' +
            '<span class="ir-sticky-price"></span>' +
            '<span class="ir-sticky-save-pill"></span>' +
          '</div>' +
        '</div>' +
        '<button class="ir-sticky-btn" type="button" aria-label="Add to cart">' +
          '<span class="ir-sticky-btn-text">ADD TO CART</span>' +
          '<span class="ir-sticky-btn-arrow">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
              '<line x1="3" y1="15" x2="15" y2="3"/>' +
              '<polyline points="7 3 15 3 15 11"/>' +
            '</svg>' +
          '</span>' +
        '</button>' +
      '</div>';
    document.body.appendChild(bar);
    return bar;
  }

  function applyState(bar, d) {
    var labelEl    = bar.querySelector('.ir-sticky-label');
    var priceEl    = bar.querySelector('.ir-sticky-price');
    var rrpEl      = bar.querySelector('.ir-sticky-rrp');
    var savePillEl = bar.querySelector('.ir-sticky-save-pill');
    var qtyLabel   = d.qty === 1 ? '1 Jar' : d.qty + ' Jars';
    var typeLabel  = d.purchaseType === 'subscribe' ? 'Subscribe & Save' : 'One-Time';
    if (labelEl)    labelEl.textContent = qtyLabel + ' · ' + typeLabel;
    if (priceEl)    priceEl.textContent = fmt(d.price);
    var hasSavings = d.fullRRP > d.price;
    if (rrpEl) {
      rrpEl.textContent   = hasSavings ? fmt(d.fullRRP) : '';
      rrpEl.style.display = hasSavings ? '' : 'none';
    }
    if (savePillEl) {
      savePillEl.textContent   = hasSavings ? 'SAVE ' + d.savingsPct + '%' : '';
      savePillEl.style.display = hasSavings ? '' : 'none';
    }
  }

  /* Hardcoded fallback matching the bundle widget's initial default state */
  var DEFAULT_STATE = {
    qty: 2, purchaseType: 'subscribe',
    price: 168.48, fullRRP: 246.99, savings: 78.51, savingsPct: 32
  };

  function initStickyATC() {
    if (!document.querySelector('.ir-b-widget')) return;
    if (document.getElementById('ir-sticky-atc')) return;

    var bar = createBar();
    /* Inline visibility:hidden is bulletproof against any CSS cascade —
       the bar is completely invisible at creation regardless of class state.
       We strip it exactly once, the first time the bar legitimately shows. */
    bar.style.visibility = 'hidden';
    bar.setAttribute('aria-hidden', 'true');

    var hasBeenShown  = false;
    var lastHideTime  = 0;
    /* pendingDrawerHide: set on any ATC click, cleared only when the drawer
       actually closes (or after a 5 s safety timeout in case of network failure).
       While true, showBar() is completely blocked — no time-based race condition. */
    var pendingDrawerHide      = false;
    var pendingDrawerHideTimer = null;

    /* ── Drawer detection ────────────────────────────────────────────────
       Check both body.overflow-hidden (cart-drawer.js L49) and
       cart-drawer.active (cart-drawer.js L34). */
    function isDrawerOpen() {
      if (document.body.classList.contains('overflow-hidden')) return true;
      var cd = document.querySelector('cart-drawer');
      return cd ? cd.classList.contains('active') : false;
    }

    /* ── Show / hide helpers ─────────────────────────────────────────── */
    function showBar() {
      if (isDrawerOpen() || pendingDrawerHide) return;
      /* 600 ms cooldown absorbs spurious IO misfires from mobile address-bar
         animation — but only for scroll-triggered hides, not drawer hides
         (which are blocked by pendingDrawerHide above). */
      if (Date.now() - lastHideTime < 600) return;
      bar.style.zIndex     = '';
      bar.style.display    = '';
      bar.style.visibility = '';
      hasBeenShown = true;
      bar.classList.add('visible');
      bar.setAttribute('aria-hidden', 'false');
      document.body.style.paddingBottom = bar.offsetHeight + 'px';
    }

    function hideBar() {
      /* Only stamp lastHideTime when the bar was actually visible —
         the scroll listener fires hideBar() continuously while the button
         is in view, and updating the timestamp on every tick would keep
         the showBar() cooldown alive indefinitely. */
      if (bar.classList.contains('visible')) lastHideTime = Date.now();
      bar.classList.remove('visible');
      bar.style.visibility = 'hidden';
      bar.setAttribute('aria-hidden', 'true');
      document.body.style.paddingBottom = '';
    }

    /* Immediate, synchronous hide — called on ATC click BEFORE the drawer
       animation starts. Sets pendingDrawerHide so showBar() stays blocked
       for the entire duration of the network request + drawer open animation,
       regardless of how long the mobile network takes. */
    function hideImmediately() {
      lastHideTime = Date.now();
      pendingDrawerHide = true;
      clearTimeout(pendingDrawerHideTimer);
      /* Safety reset: if the drawer never opens (e.g. network error), unblock
         showBar() after 5 s so the bar can work normally again. */
      pendingDrawerHideTimer = setTimeout(function () {
        pendingDrawerHide = false;
      }, 5000);
      bar.classList.remove('visible');
      bar.style.visibility = 'hidden';
      bar.style.display    = 'none';
      bar.style.zIndex     = '-1';
      bar.setAttribute('aria-hidden', 'true');
      document.body.style.paddingBottom = '';
    }

    function hideForDrawer() {
      if (!isDrawerOpen()) return;
      hideImmediately();
    }

    /* ── IntersectionObserver — button entering / leaving viewport ───────
       IO is the browser-native API for this exact task. It fires the moment
       the button crosses the viewport boundary in either direction, handling
       iOS momentum scroll and position:sticky parents correctly — none of
       which setInterval + getBoundingClientRect can reliably do.

       The observer is set up lazily so it still works when the bundle widget
       renders after DOMContentLoaded. Retries every 250 ms until found. */
    /* ── Price / label updates ───────────────────────────────────────── */
    applyState(bar, calcFromDOM() || DEFAULT_STATE);
    setInterval(function () {
      applyState(bar, calcFromDOM() || window.__irBundleState || DEFAULT_STATE);
    }, 300);

    function setupIntersectionObserver() {
      var btn = document.querySelector('.ir-b-widget .ir-b-atc-btn') ||
                document.querySelector('.ir-b-atc-btn');
      if (!btn || (btn.offsetWidth === 0 && btn.offsetHeight === 0)) return false;

      new IntersectionObserver(function (entries) {
        if (isDrawerOpen()) return;
        var inView = entries[0].isIntersecting;
        if (!inView) {
          /* Only show when the button is ABOVE the viewport (user scrolled
             past it going down). rect.top < 0 means the element's top edge
             is above the viewport top. If rect.top > 0 the button is below
             the viewport — user is above the product section, don't show. */
          var rect = btn.getBoundingClientRect();
          if (rect.top < 0) showBar();
        } else if (hasBeenShown) {
          hideBar();
        }
      }, { threshold: 0 }).observe(btn);

      return true;
    }

    /* ── Scroll listener — belt-and-suspenders for hide-on-scroll-up ───────
       IO handles show (fires once when button leaves viewport going down).
       Scroll handles hide (fires continuously so the moment the button is
       back in the viewport the bar disappears, even on sticky-parent desktop). */
    window.addEventListener('scroll', function () {
      if (!hasBeenShown || isDrawerOpen()) return;
      var btn = document.querySelector('.ir-b-widget .ir-b-atc-btn') ||
                document.querySelector('.ir-b-atc-btn');
      if (!btn) return;
      var rect = btn.getBoundingClientRect();
      /* Button visible in viewport → hide bar */
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        hideBar();
      }
    }, { passive: true });

    /* Retry until bundle widget has rendered */
    var ioReady = setupIntersectionObserver();
    if (!ioReady) {
      var ioAttempts = 0;
      var ioTimer = setInterval(function () {
        ioAttempts++;
        if (setupIntersectionObserver() || ioAttempts > 24) clearInterval(ioTimer);
      }, 250);
    }

    /* ── Drawer MutationObservers ────────────────────────────────────────
       Instant response when cart opens/closes — no polling delay. */
    if (window.MutationObserver) {
      new MutationObserver(hideForDrawer)
        .observe(document.body, { attributes: true, attributeFilter: ['class'] });
      var cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl) {
        new MutationObserver(function () {
          if (isDrawerOpen()) {
            hideForDrawer();
          } else if (hasBeenShown || pendingDrawerHide) {
            /* Drawer closed — clear the pending flag, restore stacking and display */
            pendingDrawerHide = false;
            clearTimeout(pendingDrawerHideTimer);
            bar.style.zIndex  = '';
            bar.style.display = '';
            var btn = document.querySelector('.ir-b-widget .ir-b-atc-btn') ||
                      document.querySelector('.ir-b-atc-btn');
            if (btn && btn.getBoundingClientRect().top < 0) showBar();
            else hideBar();
          }
        }).observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
      }
    }

    /* ── Click ─────────────────────────────────────────────────────────── */

    /* Proactively hide on any ATC click (capture phase = fires first).
       This runs synchronously before the cart drawer animation starts,
       preventing the bar from appearing behind the drawer on real iPhones. */
    document.addEventListener('click', function (e) {
      if (e.target.closest('.ir-b-atc-btn, .ir-sticky-btn')) {
        hideImmediately();
      }
    }, true);

    var stickyBtn = bar.querySelector('.ir-sticky-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var mainBtn = document.querySelector('.ir-b-atc-btn');
        if (!mainBtn || mainBtn.disabled) return;
        stickyBtn.disabled = true;
        mainBtn.click();
        var poll = setInterval(function () {
          if (!mainBtn.disabled) { stickyBtn.disabled = false; clearInterval(poll); }
        }, 100);
        setTimeout(function () { stickyBtn.disabled = false; clearInterval(poll); }, 8000);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATC);
  } else {
    initStickyATC();
  }
})();
